module.exports = __webpack_public_path__ + "63b24dac1ef270575e04620f2dd45fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Digi/banner-desktop-text.png
// module id = 1423
// module chunks = 13